export default __webpack_public_path__ + "static/media/onboardingLogo.0eedb68c.png";